import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import AccessGrantForm, { type AccessGrantFormProps } from '@/frontend/features/IntegrationAccess/AccessGrantForm'

export default function GrantDialog({ open, ...props }: AccessGrantFormProps & { open: boolean }) {
  return <Dialog open={open} onOpenChange={(value) => { if (!value) props.onClose() }}><DialogContent className="max-h-[90dvh] overflow-y-auto sm:max-w-lg">
    <DialogHeader><DialogTitle>{props.grant ? props.snapshot.copy.edit_grant : props.snapshot.copy.new_grant}</DialogTitle></DialogHeader>
    <AccessGrantForm {...props} />
  </DialogContent></Dialog>
}
